import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-sales-list",
    template: `
        <section-warehouse-order-list [state]="state" [type]="'sales'"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderSalesListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-sales",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
